import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 11,
	height: 11,
	viewBox: "0 0 11 11",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.56506 0.341558C7.78382 0.122859 8.08048 0 8.38981 0C8.69913 0 8.9958 0.122859 9.21456 0.341558L10.6582 1.7852C10.7665 1.89353 10.8525 2.02216 10.9112 2.16372C10.9698 2.30529 11 2.45702 11 2.61026C11 2.7635 10.9698 2.91523 10.9112 3.0568C10.8525 3.19837 10.7665 3.32699 10.6582 3.43532L3.72129 10.3724L0 11L0.628186 7.27862L7.56506 0.341558ZM7.43149 2.12467L8.87509 3.56831L9.83341 2.60997L8.38981 1.16691L7.43149 2.12467ZM8.04976 4.39367L6.60674 2.95003L1.71657 7.84032L1.42319 9.57678L3.15959 9.28396L8.04976 4.39367Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
